var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"generalstate__wrapper"}},[_c('POIStep',{attrs:{"position":_vm.position,"step":_vm.step,"title":"Status"},on:{"changeStep":_vm.changeStep}},[_c('POIGeneralStateField',{attrs:{"editedItem":_vm.editedItem,"isOwnedBySubPrincipal":_vm.isOwnedBySubPrincipal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }